var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#2C6734",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m458 80h-202v-26c0-29.776-24.225-54-54-54h-148c-29.775 0-54 24.224-54 54v50 306c0 29.776 24.225 54 54 54h234c13.255 0 24-10.745 24-24s-10.745-24-24-24h-234c-3.309 0-6-2.691-6-6v-282h410c3.309 0 6 2.691 6 6v226c0 13.255 10.745 24 24 24s24-10.745 24-24v-226c0-29.776-24.225-54-54-54zm-404-32h148c3.309 0 6 2.691 6 6v26h-160v-26c0-3.309 2.691-6 6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m408 368c-13.255 0-24 10.745-24 24v24h-24c-13.255 0-24 10.745-24 24s10.745 24 24 24h24v24c0 13.255 10.745 24 24 24s24-10.745 24-24v-24h24c13.255 0 24-10.745 24-24s-10.745-24-24-24h-24v-24c0-13.255-10.745-24-24-24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFolder);
export default __webpack_public_path__ + "static/media/add-folder.426d3b719089b79092447f647a4267b2.svg";
export { ForwardRef as ReactComponent };